exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ruleText[data-v-1896f179]{border-left:2px solid grey;margin-top:4px}.ruleText[data-v-1896f179]:nth-child(2n){border-left:2px solid #c62d2d}.ruleItem[data-v-1896f179]{height:40px;display:flex;flex-flow:column}.ruleText p[data-v-1896f179]{padding-left:10px}.disclaimer[data-v-1896f179]{padding:10px;font-family:Roboto,sans-serif;font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1896f179","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Static/rules.vue
// module id = 417
// module chunks = 0